import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconScissors12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconScissors12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Scissors12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M11.932 2.565a.506.506 0 0 1-.173.69l-7.7 4.674q.121.337.123.717a2.103 2.103 0 0 1-2.092 2.116c-1.155 0-2.092-.947-2.092-2.116S.935 6.529 2.09 6.529c.549 0 1.048.214 1.421.563L5.311 6l-1.8-1.093c-.373.35-.872.564-1.42.564-1.156 0-2.093-.948-2.093-2.117S.935 1.238 2.09 1.238s2.092.947 2.092 2.116q-.002.38-.123.716l2.215 1.345 4.975-3.02a.494.494 0 0 1 .683.17M2.09 4.471A1.104 1.104 0 0 1 .998 3.354c0-.628.5-1.116 1.092-1.116s1.092.488 1.092 1.116-.5 1.117-1.092 1.117m0 5.291A1.104 1.104 0 0 1 .998 8.646c0-.628.5-1.117 1.092-1.117s1.092.489 1.092 1.117c0 .627-.5 1.116-1.092 1.116m6.608-2.828.039-.024 3.022 1.835a.506.506 0 0 1 .172.69.494.494 0 0 1-.682.17l-3.476-2.11z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Scissors12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconScissors12);
